export const SAVE_ALL_IDENTIFIED_PROBLEMS = 'SAVE_ALL_IDENTIFIED_PROBLEMS'
export const SAVE_IDENTIFIED_PROBLEM = 'SAVE_IDENTIFIED_PROBLEM'
